import { isWeChatBrowser } from "./browser";

const ensureMetaTag = (attributes) => {
  if (typeof document === "undefined") return null;
  const head = document.head || document.getElementsByTagName("head")[0];
  if (!head) return null;

  const selector = Object.entries(attributes)
    .map(([k, v]) => `meta[${k}="${String(v).replace(/"/g, '\\"')}"]`)
    .join("");

  let el = selector ? document.querySelector(selector) : null;
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attributes).forEach(([k, v]) => el.setAttribute(k, v));
    head.appendChild(el);
  }
  return el;
};

const setMetaContent = (attributes, content) => {
  const el = ensureMetaTag(attributes);
  if (!el) return;
  if (content === undefined || content === null || content === "") return;
  el.setAttribute("content", String(content));
};

export const setShareMeta = ({
  title,
  description,
  image,
  url,
  type = "website",
} = {}) => {
  if (typeof document === "undefined") return;

  if (title) {
    document.title = String(title);

    // WeChat iOS sometimes doesn't refresh <title> reliably; this "iframe ping"
    // is a common workaround to force the title bar + share panel to update.
    try {
      const ua = typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
      const isWeChat = isWeChatBrowser();
      const isIOS = /iPhone|iPad|iPod/i.test(ua);
      if (isWeChat && isIOS && typeof window !== "undefined") {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = `${process.env.PUBLIC_URL || ""}/favicon.ico`;
        iframe.onload = () => {
          setTimeout(() => {
            try {
              iframe.parentNode?.removeChild(iframe);
            } catch (_) {
              // ignore
            }
          }, 0);
        };
        document.body?.appendChild(iframe);
      }
    } catch (_) {
      // ignore
    }
  }

  setMetaContent({ name: "description" }, description);
  setMetaContent({ itemprop: "name" }, title);
  setMetaContent({ itemprop: "description" }, description);
  setMetaContent({ itemprop: "image" }, image);

  setMetaContent({ property: "og:type" }, type);
  setMetaContent({ property: "og:title" }, title);
  setMetaContent({ property: "og:description" }, description);
  setMetaContent({ property: "og:image" }, image);
  setMetaContent({ property: "og:image:alt" }, title);
  setMetaContent({ property: "og:image:type" }, image ? "image/png" : undefined);
  setMetaContent({ property: "og:url" }, url);

  setMetaContent({ name: "twitter:card" }, "summary");
  setMetaContent({ name: "twitter:title" }, title);
  setMetaContent({ name: "twitter:description" }, description);
  setMetaContent({ name: "twitter:image" }, image);
};

